<template>
    <div class="take-face-manual">
        <Tag style="width: 100%; text-align: center;" color="warning" size="large">人脸识别</Tag>
        <!-- 人脸照片 -->
        <div class="face-holder">
            <div v-show="false" ref="faceImg" class="face-img"></div>
            <div id="hoder">
                <video id="video" class="video" preload autoplay loop muted></video>
                <canvas id="canvas" class="video"></canvas>
                <!-- <Loader v-if="buttonStatus.loading"/>
                <Loader v-else :red="true"/> -->
            </div>
        </div>
        <!-- 状态提示 -->
        <div v-if="status === 0">
            根据要求，学习过程中需要进行人脸识别
        </div>
        <div v-if="status === 2" class="info warning">
            <Icon type="md-information-circle" size="22" />照片中没有检测到人脸
        </div>

        <div v-if="status === 4" class="info success">
            <Icon type="md-checkmark-circle" size="22"/>识别成功
        </div>

        <div v-if="status === 5 || status === 6" class="info warning">
            <Icon type="md-information-circle" size="22" />人脸匹配度低
        </div>

        <!-- 拍照签到按钮 -->
        <!-- <div class="face-button">
            <Button :type="buttonStatus.type"
                        :loading-text="buttonStatus.loadingText"
                        :disabled="!buttonStatus.enabled"
                        @click="onButtonClicked"
                        >
                {{ buttonStatus.text }}
            </Button>
        </div> -->
    </div>
</template>

<script>
import Compressor from 'compressorjs';
import CommonDao from '@/../public/static/js/dao/CommonDao';
import FaceSignInRecordDao from '@/../public/static/js/dao/FaceSignInRecordDao';
// import Loader from '@/components/Loader';

export default {
    props: {
        /**
         * clientConfig 配置信息，说明
         * { faceMinCount: 2, // 跳过次数
         *   skip: true, // 是否需要跳过
         *   blank: false, // 路由是否重新打开页面
         *   examRecordId: examRecordId, // 考试 ID
         *   coursewareCode: coursewareCode, // 课件 ID
         *   chapterId: this.playedVideoChapter.id, // 章节 ID
         *   faceSignInScene: FACE_SIGNIN_SCENE.BEFORE_EXAMINATION // 签到场景
         *   route: { name | path | params } // 路由信息
         * }
         */
        clientConfig: { type: Object },
    },
    components: {  },
    data() {
        return {
            // 状态:
            //    0: 自动识别中, 请正对摄像头
            //    1: 人脸检测中
            //    2: 无人脸，再试一次
            //    3: 有人脸，人脸对比中
            //    4: 签到成功，1s 后自动跳转
            //    5: 签到失败，再试一次
            //    6: 签到失败，超过尝试次数
            status          : 0,
            completeCount   : 2, // 比对次数
            delayTime       : 5, // 延迟时间 默认 5分钟
            tracker         : {}, //人脸追踪器
            trackerTask     : {}, // 用于控制食品和画布的工具
            video           : {}, // 页面视频元素
            canvas          : {}, // 页面画布元素
            context         : {}, // 画布内容
            captures        : [], // 截图列表
            lastTime        : 0,
            faceImgUrl      : '', // 人脸签到照片临时路径
            clazzId         : '', // 班级 ID
            faceSignInRecord: {
                coursewareCode : '',
                chapterId      : 0,
                examRecordId   : 0,
                faceSignInScene: 0,
                userId         : 0,
                faceSignInImg  : '',
            },
        };
    },
    mounted() {
        let uId = this.$route.query.uid;
        this.token = Utils.getCookie(uId);
        Promise.all([
            Utils.loadJs('/static/lib/face/adapter.js'),
            Utils.loadJs('/static/lib/face/tracking-min.js'),
            Utils.loadJs('/static/lib/face/tracking-face-min.js'),
        ]).then(() => {
            // 开启抓拍
            this.startTakeFace();
        });
    },
    methods: {
        showFace(file) {
            // 1. 压缩图片
            // 2. 显示图片
            // 3. 上传图片
            // 4. 检测图片中是否有人脸

            let imgFile = file;
            if (!imgFile) { return; }

            // [1] 压缩图片
            const comp = new Compressor(imgFile, {
                quality  : 1,
                maxWidth : 640,
                maxHeight: 480,
                success  : blob => {
                    // [2] 显示图片
                    // const src = URL.createObjectURL(blob);
                    // this.$refs.faceImg.style.backgroundImage = `url(${src})`; // 使用背景显示图片比 <img> 的效果好一些
                    // console.log('blob', blob);
                    // // [3] 上传图片
                    this.status = 1; // 人脸检测中
                    CommonDao.uploadBlobImage(blob).then(uploadedImage => {
                        // [4] 检测图片中是否有人脸
                        const tempUrl = uploadedImage.url;
                        this.faceImgUrl = tempUrl;
                        // 检测是否存在人脸
                        // this.detectFace(tempUrl);
                        // 对比是否匹配
                        this.compareFace(tempUrl);
                    });
                },
            });
        },
        // 检测图片中是否有人脸
        detectFace(tempUrl) {
            // 1. 检测图片中是否有人脸
            // 2. 无人脸，则提示
            // 3. 有人脸，则自动签到
            CommonDao.detectFace(tempUrl).then(faceCount => {
                if (faceCount > 0) {
                    this.status = 3; // 有人脸，签到中
                    this.compareFace(tempUrl);
                } else {
                    this.status = 2; // 无人脸，再试一次
                    this.complete += 1;
                }
            });
        },
        // 人脸对比签到
        compareFace(tempUrl) {
            // 比对结束发射信号 on-complete
            CommonDao.compareFace(tempUrl, this.token).then(matched => {
                // this.status = 4; // 比对成功
                this.complete(matched); // 完成 matched = true 则通过, 否则不通过
                // if (matched) {
                //     this.status = 4; // 比对成功
                //     this.complete(); // 完成
                // } else {
                //     this.failTimes += 1;
                //     setTimeout(() => {
                //     // 允许跳过时超过最大尝试次数，则显示跳过按钮
                //         if (this.clientConfig.skip === 1 && this.clientConfig.faceMinCount != -1 && this.failTimes >= this.clientConfig.faceMinCount) {
                //             this.status = 6;
                //         } else {
                //             this.status = 5;
                //         }
                //     }, 1000);
                // }
            });
        },
        // 完成
        complete(matched) {
            // 对比次数 递减
            this.completeCount-=1;
            // 人脸签到记录状态
            // if (this.status === 4) {
            //     // 签到成功
            //     this.faceSignInRecord.faceSignInStatus = 1;
            // }
            // if (this.status === 6) {
            //     // 签到失败
            //     this.faceSignInRecord.faceSignInStatus = 0;
            // }
            // 对比是否匹配 matched = true 则通过, 否则不通过
            if (matched) this.faceSignInRecord.faceSignInStatus = matched?1:0;
            // 记录人脸签到数据, 包括照片地址
            this.faceSignInRecord.coursewareCode  = this.clientConfig.coursewareCode === '' ? 0 : this.clientConfig.coursewareCode; // 课件编码
            this.faceSignInRecord.chapterId       = this.clientConfig.catalogId === undefined ? 0 : this.clientConfig.catalogId;       // 章节 ID
            this.faceSignInRecord.examRecordId    = this.clientConfig.examRecordId === undefined ? 0 : this.clientConfig.examRecordId; // 考试记录 ID
            this.faceSignInRecord.examId          = this.clientConfig.examId === undefined ? 0 : this.clientConfig.examId; // 考试 ID
            this.faceSignInRecord.faceSignInScene = this.clientConfig.faceSignInScene; // 设置场景
            this.faceSignInRecord.userId          = this.clientConfig.userId;  // 用户 ID
            this.faceSignInRecord.faceSignInImg   = this.faceImgUrl; // 照片 url
            const self = this;
            FaceSignInRecordDao.saveTakeFaceRecord(self.faceSignInRecord, self.token).then((newFaceSignInRecord) => {
                newFaceSignInRecord;
                // console.log('newFaceSignInRecord', newFaceSignInRecord);
                // 弹出框 1 秒后自动关闭
                // self.$emit('on-complete');
                // 关闭摄像头
                // self.onStopTracking();
                if (!matched) {
                    // console.log('matched 失败', matched);
                    this.$router.push({
                        name: 'player-error',
                        params: {
                            error: '抓拍人脸不匹配，停止学习！'
                        }
                    });
                } else {
                    // console.log('matched 成功', matched);
                    if (this.completeCount>0) {
                        setTimeout(() => {
                            // console.log('matched 成功 后60秒再执行');
                            // 开启抓拍
                            self.startTakeFace();
                        }, this.delayTime*60*1000);
                    }
                }
            });
        },
        // 开启抓拍
        startTakeFace() {
            // console.log('开始抓拍');
            // // 比对成功或者当尝试达到最大次数时
            // if (this.status === 4 || this.status === 6) {
            //     this.complete();
            // }
            try {
                this.status = 0;
                setTimeout(() => {
                    this.initTracker();
                }, 100);
            } catch (error) {
                console.log('error', error);
                console.log('error.name', error.name);
                const msgs =  MEDIA_ERROR_MSG.find(t => t.name === error.name);
                if (msgs) {
                    Utils.warning(msgs.title, msgs.msg);
                } else {
                    this.$Message.warning('调用摄像头错误');
                }
            }
        },
        initTracker() {
            const self = this;
            this.video = document.getElementById('video');
            this.canvas = document.getElementById('canvas');
            this.context = this.canvas.getContext('2d');
            this.canvas.width  = 240; // canvas 的实际宽度，默认是 300
            this.canvas.height = 240;
            // 初始化tracking参数
            this.tracker = new tracking.ObjectTracker('face');
            this.tracker.setInitialScale(4);
            this.tracker.setStepSize(2);
            this.tracker.setEdgesDensity(0.1);
            this.tracker.on('track', event => {
                self.onTracked(event);
            });

            // 如果是读取视频，可以用trackerTask.stop trackerTask.run来暂停、开始视频
            this.trackerTask = tracking.track(this.video, this.tracker);

            // 启用摄像头
            tracking.track(this.video, this.tracker, { camera: true });
        },
        onTracked(event) {
            let _this = this;

            // 判断终止条件, stop是异步的，不返回的话，还会一直截图
            if (this.status === 4 || this.status === 6) {
                this.onStopTracking();
                return;
            }

            // 画框框
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

            event.data.forEach(rect => {
                _this.context.lineWidth = 1;
                _this.context.strokeStyle = '#50e3ce';
                _this.context.strokeRect(rect.x, rect.y, rect.width, rect.height);

                // rect 的中心在 120 - 20 内
                const cx = rect.x + rect.width / 2;
                const cy = rect.y + rect.height / 2;

                // 1 秒
                if ((30 < cx && cx < 140) && (30 < cy && cy < 140) && Date.now() - _this.lastTime > 1000) {
                    _this.lastTime = Date.now();
                    // status 为 0 或 2 或 5 才截图
                    if (_this.status === 0 || _this.status === 2 || _this.status === 5) {
                        // console.log('_this.status', _this.status);
                        _this.captureImage(rect.x, rect.y, rect.width, rect.height);
                    }
                }
                // console.log(rect.x, rect.y, rect.width, rect.height);
                // console.log(_this.video.videoWidth, _this.video.videoHeight);
            });
        },
        onStopTracking() {
            this.trackerTask.stop();
            this.video.pause();
            this.video.srcObject.getVideoTracks().forEach(videoTrack => {
                videoTrack.stop();
            });
        },
        captureImage(x, y, width, height) {
            const buffer = 25;
            var bufferCanvas = document.createElement('canvas');
            var bfx = bufferCanvas.getContext('2d');

            bufferCanvas.width = this.video.videoWidth;
            bufferCanvas.height = this.video.videoHeight;
            bfx.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight);
            // 裁剪出有人脸的图片时, 进行识别对比
            this.status = 1;

            // bufferCanvas.width = width;
            // bufferCanvas.height = height;
            // bfx.drawImage(this.video, -x + buffer, -y + buffer * 2, width*2, height*2);

            // this.captures.push(bufferCanvas.toDataURL('image/png'));

            const file = Utils.dataURLtoFile(bufferCanvas.toDataURL('image/png'), 'faceImg.png');
            this.showFace(file);
        },
    },
    computed: {
        // 按钮的状态
        buttonStatus() {
            return FACE_SIGNIN_BUTTON_STATUSES[this.status];
        },
        // 是否可拍照
        canCapture() {
            return this.buttonStatus.enabled && this.status !== 4 && this.status !== 6;
        },
    },
    destroyed() {
        // 关闭摄像头
        this.onStopTracking();
    }
};
</script>

<style lang="scss">
.take-face-manual {
    // display: grid;
    // justify-items: center;
    // grid-gap: 30px;
    // padding-top: 80px;
    position: fixed;
    z-index: 0;

    .face-holder {
        height: 250px;
        #hoder {
            // width: 240px;
            height: 240px;
            width: 240px;
            border-radius: 100%;
            margin: 0 auto;
            overflow: hidden;
            // position: absolute;
            // background: #ff0030;
        }

        #video, #canvas {
            position: absolute;
            width: 240px !important;
            height: 240px !important;
            left: 50%;
            transform: translateX(-50%);
            // transform: translateX(-50%) translateY(-50%);
            border-radius: 100%;
            box-sizing: border-box;
            border: 3px solid gray;
        }

        #video {
            object-fit: cover;
            object-position:center;
        }

        #canvas {
            // background: rgba(0, 0, 0, 0.4);
        }
    }

    .face-button {
        position: relative;
        display: inline-block;

        button {
            min-width: 150px;
        }
    }

    .info {
        // font-size: 18px;
        display: flex;
        align-items: center;
        line-height: 20px;

        .icon {
            margin-right: 8px;
        }

        &.warning {
            color: $errorColor;
        }
        &.success {
            color: $successColor;

        }
    }
}
</style>
